module.exports = __webpack_public_path__ + "static/img/kit_93-695-399-653.e68fabc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/kit_93-695-399-653.jpg
// module id = Rn9i
// module chunks = 0